module.exports = __webpack_public_path__ + "media/bootstrap-icons/shuffle-20679469.svg";